import React, { useState, useEffect, useCallback } from "react";
import { Container, Row } from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";
import { MdArrowBackIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from 'react-bootstrap/Button';
import { GoChevronRight } from "react-icons/go";
import { useParams } from 'react-router-dom';
import * as ascentwebApi from "../../api/ascentwebApi"
import * as profileApi from "../../api/profileApi"
import { useSignalAbort } from "../../api/useSignalAbort";
import { handleApiErrors } from '../../api/handleApiErrors';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertDateForApi } from "../../HelperFile";

const Divider = () => (
    <div style={{ borderBottom: '2px solid #dee2e6', margin: '20px 0'}}></div>
  );
const defaultValue = {
  FullName: "",
  Gender: "",
  State: "",
  DateofBirth: "",
  MaritalStatus:"",
  MobileNo: "",
  Email:"",
  Qualifications:"",
  Certifications: "",
  CurrentJobTitle: "",
  ReleventExperience:"",
  EmploymentStatus: "",
  CurrentEmployer:"",
  CurrentSalary: "",
  Sources:"",
  Country: "",
  ExpectedSalary: "",
  Resume: ""
}
function CandidateForm() {
  const { Jobcode } = useParams()
  const navigate = useNavigate();
  const abortConstants = useSignalAbort()
  const [validated, setValidated] = useState(false);
  const [Country,setCountry] = useState()
  const [Countryselect,setCountryselect] = useState("")
  const [State,setState] = useState()
  const [Stateselect,setStateselect] = useState("")
  const [Qualifications,setQualifications] = useState()
  const [Qualificationsselect,setQualificationsselect] = useState("")
  const [Sources,setSources] = useState()
  const [Sourcesselect,setSourcesselect] = useState("")
  const [Profile,setProfile] = useState(defaultValue)
  const [Genderselect,setGenderselect] = useState("")
  const [ReleventExperienceselect,setReleventExperienceselect] = useState("")
  const [MaritalStatusselect,setMaritalStatusselect] = useState("")
  const [EmployementStatus,setEmployementStatus] = useState()
  const [EmployerStatusselect,setEmployerStatusselect] = useState("")
  const [selectedFile, setSelectedFile] = useState(null);   
  const [isLoading, setIsLoading] = useState({})
  const [issubmit,setIsSubmit] = useState(false)

  const handleFileChange = (event) => {   
    console.log(event.target.files); 
     const file = event.target.files[0];

  // Check if a file is selected
  if (file) {
    // Check the file size (in bytes)
    const fileSize = file.size;

    // Convert fileSize to kilobytes (KB)
    const fileSizeInKB = fileSize / 1024;

    // Set the maximum allowed file size (500 KB in this example)
    const maxFileSizeKB = 500;

    // Check if the file size exceeds the maximum allowed size
    if (fileSizeInKB > maxFileSizeKB) {
      // File size is too large, handle the error (display a message, etc.)
      alert("File size is too large. Please select a file smaller than 500 KB.");
      // You can also set an error state or display a message to the user.
    } else {
      // File size is within the allowed limit, proceed with handling the file
      // Update your state or perform other actions with the file
      // console.log("File size is within the limit. Proceed with handling the file.");
      // For example, set the selectedFile state:
      setSelectedFile(event.target.files[0]);  
    }
  }
     };
  
  //getCountry
  const getCountry = async (abortToken) => {
    try {
      const result = await ascentwebApi.getCountry(Countryselect, abortToken);
      console.log(result?.data?.Country);
      setCountry(result?.data?.Country);
      setCountryselect(result?.data?.Country[0].countryId)
    } catch (error) {
      handleApiErrors(error, 'Country', 'country_response', 'country_timeout', 'country_request', setIsLoading)
    }
  };
  //getState
  const getState = async (abortToken) => {
    try {
      const result = await ascentwebApi.getState(Stateselect, abortToken);
      console.log(result?.data?.State);
      setState(result?.data?.State);
      setStateselect(result?.data?.State[0].StateId)
    } catch (error) {
      handleApiErrors(error, 'State', 'state_response', 'state_timeout', 'state_request', setIsLoading)
    }
  };
  //Qualifications
  const getQualifications = async (abortToken) => {
    try {
      const result = await ascentwebApi.getQualifications(Stateselect, abortToken);
      console.log(result?.data?.Qualifications);
      setQualifications(result?.data?.Qualifications);
      setQualificationsselect(result?.data?.Qualifications[0].QualificationsId)
    } catch (error) {
      handleApiErrors(error, 'Qualifications', 'qualifications_response', 'qualifications_timeout', 'qualifications_request', setIsLoading)
    }
  };
  //Sources
  const getSources = async (abortToken) => {
    try {
      const result = await ascentwebApi.getSources(Sourcesselect, abortToken);
      console.log(result?.data?.Sources);
      setSources(result?.data?.Sources);
      setSourcesselect(result?.data?.Sources[0].SourcesId)
    } catch (error) {
      handleApiErrors(error, 'Sources', 'sources_response', 'sources_timeout', 'sources_request', setIsLoading)
    }
  };
   //EmployementStatus
   const getEmployementStatus = async (abortToken) => {
    try {
      const result = await ascentwebApi.getEmployementStatus(EmployerStatusselect, abortToken);
      console.log(result?.data?.EmployementStatus);
      setEmployementStatus(result?.data?.EmployementStatus);
      setEmployerStatusselect(result?.data?.EmployementStatus[0].Id)
    } catch (error) {
      handleApiErrors(error, 'EmployementStatus', 'employementstatus_response', 'employementstatus_timeout', 'employementstatus_request', setIsLoading)
    }
  };

 //Profile
 const profile = async (formData) => {
  const newData = {
    data: JSON.stringify(formData),
    file: selectedFile,
  };
  console.log(newData);
  try {
    const result = await profileApi.Profile(newData);
    console.log(result);
    setIsSubmit(false);
    setProfile(defaultValue)
      setValidated(false)
      setReleventExperienceselect("")
      setGenderselect("")
      setMaritalStatusselect("")
      setQualificationsselect("")
      setEmployerStatusselect("")
      setSourcesselect("")
      setCountryselect("")
      setSelectedFile(null)
    // alert(result.data.message);
    toast.success( result.data.message,{
      autoClose: 3000, // Close the toast after 5 seconds
  });
  } catch (error) {
    setIsSubmit(false);
    console.error(error);
    handleApiErrors(error, "Profile", "profile_response", "profile_timeout", "profile_request", setIsLoading);
  }
};


  const getAllData = useCallback((abortToken) => {
    getCountry(abortToken);
    getState(abortToken);
    getQualifications(abortToken);
    getSources(abortToken);
    getEmployementStatus(abortToken);
  }, []);

  useEffect(() => {
    getAllData(abortConstants.controllerConfig);

    // return () => {
    //   // Cleanup logic if needed
    //   abortConstants.controller.abort();
    // };
  }, [getAllData]);

  const handleCountryselect = (e) => {
    console.log(e.target.value);
    setCountryselect(e.target.value);
    console.log(Countryselect);
  }
  const handleStateselect = (e) => {
    setStateselect(e.target.value);
    console.log(Stateselect);
  }
  const handleQualifications = (e) => {
    setQualificationsselect(e.target.value);
    console.log(Qualificationsselect);
  }
  const handleSources = (e) => {
    setSourcesselect(e.target.value);
    console.log(Sourcesselect);
  }
  const handleGender = (e) => {
    setGenderselect(e.target.value);
    console.log(Genderselect);
  }

  const handleMaritalStatus = (e) => {
    setMaritalStatusselect(e.target.value);
    console.log(MaritalStatusselect);
  }
  const handleReleventExperience = (e) => {
  setReleventExperienceselect(e.target.value)
  console.log(ReleventExperienceselect);
}

  const handleEmployerStatus = (e) => {
    setEmployerStatusselect(e.target.value);
    console.log(EmployerStatusselect);
  }
  
  
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmit(true)
    const form = event.currentTarget;

    const formattedDate = convertDateForApi(Profile.DateofBirth)

    let newData = {
      FullName: Profile.FullName,
      Gender: Genderselect,
      StateId: Number(Stateselect),
      DateofBirth: formattedDate,
      MaritalStatus: MaritalStatusselect,
      MobileNo: Profile.MobileNo,
      EmailId: Profile.Email,
      QualificationsId: Number(Qualificationsselect),
      Certification: Profile.Certifications,
      CurrentJobTitle: Profile.CurrentJobTitle,
      ReleventExperience: ReleventExperienceselect,
      EmploymentStatusId: Number(EmployerStatusselect),
      CurrentEmployer: Profile.CurrentEmployer,
      CurrentSalary: Profile.CurrentSalary,
      SourcesId: Number(Sourcesselect),
      CountryId: Number(Countryselect),
      ExpectedSalary: Profile.ExpectedSalary,
      Resume:""
    };
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setIsSubmit(false);
    }

    // alert("success")
    // toast.success('success',{autoClose:3000})
    else {
      profile(newData, abortConstants.controllerConfig)
      
    }
    console.log(newData);
    setValidated(true);
  };

  const handleChange = (e) => {
    setProfile({ ...Profile, [e.target.name]: e.target.value })
  }

  // const formatDateString = (dateString) => {
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString("en-US");
  // };

  const renderLoading = (item) => {
    if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`] ) {
      return true
    }
    else {
      return false
    }
  }
  
  // const validatePhone = (phone) => {
  //   const phoneRegex = /^[0-9]{10}$/; // Customize the regex as needed
  //   return phoneRegex.test(phone);
  // };

  // const validateEmail = (email) => {
  //   const emailRegex = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/
  //   return emailRegex.test(email);
  // };

  //Styles
  const captionTextStyle = {
    fontSize: "2.1rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
    textAlign: "center",
  };
  
  const captionTextStyle2 = {
    fontSize: "2.1rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "black",
    textAlign: "center",
  };
  
  const captionformStylehead = {
    fontSize: "1.5rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
  };
  
  const captionTextStyleSpan = {
    fontSize: "1.2rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
    textAlign: "center",
  };
  
  const captionTextStyle2Span = {
    fontSize: "1.2rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "black",
    textAlign: "center",
  };

  const iconStyle = {
    border: "none",
    color: "black",
    fontSize: "20px", // Set the font size to adjust the height and width
    marginLeft:'20px',
    marginRight: "5px", // Optional: Add some margin if needed
    cursor: "pointer", // Optional: Add cursor pointer for interaction
  };

  const captionTextStyle3 = {
    fontSize: "1.2rem",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "2.5", // Adjusted for better readability
    marginBottom: "2rem",
    padding: "20px",
  };

  const captionStyle = {
    textAlign: "left",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    backgroundColor: "white",
    padding: "2px",
    width:'100%'
  };
    const formstyle = {
        width:'1200px',
        marginBottom:'50px',
        padding:'20px'
    }
    const Buttoncolstyle = {
        marginTop:'30px',
        marginBottom:'30px'
        }
    
  const colstyle = {
    marginTop:'20px'
    }
    const formstyleCaption = {
        marginBottom:'10px',
        fontSize:'1rem',
        fontWeight: 600
    }
    const buttonStyle = {
        padding: "5px",
        fontSize: "15px",
        fontWeight: 600,
        border: 'none',
        backgroundColor: '#FFE114',
        color: 'black',
      };

  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0, overflowY: "hidden" }}>
        <div>
          <Header title="home" />
        </div>

        <div>
          <Container style={{ padding: "2px", marginTop: "50px" }}>
            <Row className="d-flex justify-content-between align-items-center">
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <span
                  style={iconStyle}
                  onClick={() => {
                    window.location.href = '/Vacancies';
                  }}
                  // onClick={() => {
                  //   navigate("/");
                  // }}
                >
                  {" "}
                  <MdArrowBackIos />{" "}
                </span>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <h3 style={captionTextStyle}>
                  {" "}
                  Candidate
                  <span style={captionTextStyle2}> Form </span>
                </h3>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <h3 style={captionTextStyleSpan}>
                  {" "}
                  Job Code
                  <span style={captionTextStyle2Span}> {Jobcode}</span>
                </h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="lead" style={captionTextStyle3}>
                  Take the first step towards your new career with our simple
                  job application form. Fill in your details, attach your
                  resume, and let’s embark on a path to new opportunities
                  together.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="d-flex justify-content-center">
          <Form
            style={formstyle}
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  style={{ marginBottom: "20px" }}
                >
                  <div className="card " style={captionStyle}>
                    <div className="card-body">
                      <Col style={colstyle}>
                        <h3 style={captionformStylehead}>
                          {" "}
                          Complete the form below{" "}
                        </h3>
                        <Divider />
                      </Col>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Full Name <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            name="FullName"
                            maxLength="120"
                            value={Profile?.FullName}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Full name.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Gender <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="Gender"
                            value={Genderselect}
                            onChange={handleGender}
                          >
                            <option> </option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Gender.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label>
                            Date Of Birth{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="DateofBirth"
                            value={Profile.DateofBirth}
                            placeholder="Date Of Birth"
                            onChange={handleChange}
                          />
                          {/* Render the formatted Date of Birth */}
                          {/* <p>
                            Formatted Date of Birth:{" "}
                            {formatDateString(Profile.DateofBirth)}
                          </p> */}
                          <Form.Control.Feedback type="invalid">
                            Please provide Date Of Birth.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Marital Status{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="MaritalStatus"
                            value={MaritalStatusselect}
                            onChange={handleMaritalStatus}
                          >
                            <option> </option>
                            <option value="S">Single</option>
                            <option value="M">Married</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Marital Status.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Nationality <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="Country"
                            value={Countryselect}
                            onChange={handleCountryselect}
                          >
                            {Country ? (
                          <>
                            {Country.length !== 0 ? (
                              <>
                                {Country.map((item) => (
                                  <option
                                    key={item.countryName}
                                    name={item.countryName}
                                    value={item.countryId}
                                  >
                                    {item.countryName}
                                  </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("country") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Nationality.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Emirate/ City{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="State"
                            value={Stateselect}
                            onChange={handleStateselect}
                          >
                           {State ? (
                          <>
                            {State.length !== 0 ? (
                              <>
                                {State.map((item) => (
                                  <option
                                  key={item.StateName}
                                  name={item.StateName}
                                  value={item.StateId}
                                >
                                  {item.StateName}
                                </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("state") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Emirate/ City.
                          </Form.Control.Feedback>
                        </Col>
                      </Row>
                      <Col
                        style={{
                          ...Buttoncolstyle,
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <h6>
                          Next{" "}
                          <span style={{ fontSize: "20px" }}>
                            {" "}
                            <GoChevronRight />{" "}
                          </span>{" "}
                        </h6>
                      </Col>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6}>
                  <div className="card h-100" style={captionStyle}>
                    <div className="card-body">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12} style={{...colstyle, marginBottom:'24px'}}>
                          {/* <h3 style={captionformStylehead}> Qualifications </h3> */}
                        </Col>
                        <Divider />
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Mobile Number <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            type="text"
                            pattern="[0-9]*"
                            inputMode="numeric"
                            aria-describedby="inputGroupPrepend"
                            maxLength="15"
                            name="MobileNo"
                            value={Profile?.MobileNo}
                            onChange={handleChange}
                            // isInvalid={Profile?.MobileNo!=="" ? !validatePhone(Profile?.MobileNo) :''}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide a valid Mobile No.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Email <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                           size="lg"
                            required
                            name="Email"
                            type="email"
                            maxLength="100"
                            value={Profile?.Email}
                            onChange={handleChange}
                            // isInvalid={Profile?.Email!=="" ? !validateEmail(Profile?.Email) :''}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide a valid Email with allowed domains (e.g., example@domain.com).
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Qualification{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="Qualifications"
                            value={Qualificationsselect}
                            onChange={handleQualifications}
                          >
                            {Qualifications ? (
                          <>
                            {Qualifications.length !== 0 ? (
                              <>
                                {Qualifications.map((item) => (
                                  <option
                                  key={item.QualificationsName}
                                  // eventKey={item.QualificationsName}
                                  name={item.QualificationsName}
                                  value={item.QualificationsId}
                                >
                                  {item.QualificationsName}
                                </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("qualifications") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Qualifications.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                          Certifications (if any){" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            maxLength="100"
                            name="Certifications"
                            value={Profile?.Certifications}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Certifications.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Current Job Title{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            name="CurrentJobTitle"
                            maxLength="100"
                            value={Profile?.CurrentJobTitle}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Current Job Title.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Relevent Experience{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            maxLength="3"
                            name="ReleventExperience"
                            value={ReleventExperienceselect}
                            onChange={handleReleventExperience}
                          >
                            <option> </option>
                            <option value="0-6month">0-6month</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10+">10+</option>
                          </Form.Select>
                          
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Relevent Experience.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                          Employment Status{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="EmployementStatus"
                            value={EmployerStatusselect}
                            onChange={handleEmployerStatus}
                          >
                            {EmployementStatus ? (
                          <>
                            {EmployementStatus.length !== 0 ? (
                              <>
                                {EmployementStatus.map((item) => (
                                   <option
                                   key={item.Name}
                                  //  eventKey={item.Name}
                                   name={item.Name}
                                   value={item.Id}
                                 >
                                   {item.Name}
                                 </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("employementstatus") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Employment Status.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Current Employer{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            name="CurrentEmployer"
                            maxLength="100"
                            value={Profile?.CurrentEmployer}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Current Employer.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Current Salary{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            type="text"
                            name="CurrentSalary"
                            maxLength="100"
                            value={Profile?.CurrentSalary}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Current Salary.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            Expected Salary{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            size="lg"
                            required
                            type="text"
                            maxLength="100"
                            name="ExpectedSalary"
                            value={Profile?.ExpectedSalary}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide Expected Salary.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Label style={formstyleCaption}>
                            How did you know about us?{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            size="lg"
                            required
                            name="Sources"
                            value={Sourcesselect}
                            onChange={handleSources}
                          >
                             {Sources ? (
                          <>
                            {Sources.length !== 0 ? (
                              <>
                                {Sources.map((item) => (
                                  <option
                                  key={item.SourcesName}
                                  // eventKey={item.SourcesName}
                                  name={item.SourcesName}
                                  value={item.SourcesId}
                                >
                                  {item.SourcesName}
                                </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("sources") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {" "}
                            Please provide valid state.
                          </Form.Control.Feedback>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <h6>
                            Disclaimer <span style={{ color: "black" }}>*</span>
                          </h6>
                          <Form.Group className="mb-3" id="formGridCheckbox">
                            <Form.Check
                              type="checkbox"
                              required
                              feedback="You must agree before submitting."
                              feedbackType="invalid"
                              label="I hereby declare that the information provided is true and correct . I also understand that any willful dishonesty may render for refusal of this application or immediate termination of employment."
                            />
                          </Form.Group>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                          <Form.Group controlId="formFileLg" className="mb-3">
                            <Form.Label style={formstyleCaption}>
                              Upload Resume or Portfolio{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Form.Control
                              type="file"
                              size="lg"
                              required
                              name="Resume"
                              // value={selectedFile}
                              onChange={handleFileChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {" "}
                              Please provide Resume or Portfolio.
                            </Form.Control.Feedback>
                            <div style={{ marginTop: "5px" }}>
                              <span>
                                File types (doc, docx, pdf, rtf, png, jpeg, jpg,
                                ppt, pptx, csv, gif) size up to 5MB.
                              </span>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Col
                        style={{
                          ...Buttoncolstyle,
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {!issubmit &&<Button type="submit" size="lg" style={buttonStyle}>
                          &nbsp;&nbsp; Submit &nbsp;&nbsp;{" "}
                          <span style={{ fontSize: "20px" }}>
                            {" "}
                            <GoChevronRight />{" "}
                          </span>{" "}
                          &nbsp;&nbsp;
                        </Button>}
                        {issubmit && 
                          <Button className='btn btn-update' style={buttonStyle} >
                            <span className="btn-text">&nbsp;&nbsp;Submiting...&nbsp;&nbsp;</span><div className="spinner"></div>
                          </Button>}
                          {/* <ToastContainer /> */}
                      </Col>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Form>
        </div>

        <div>
          <Footer />
        </div>
      </Container>
    </div>
  );
}

export default CandidateForm;